import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "asset-grid flex flex-col h-full"
};
const _hoisted_2 = {
  class: "grid-header px-4 py-2.5 border-b border-slate-100/80 flex items-center justify-between shrink-0 bg-white"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "flex items-center gap-0.5"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "grid-body flex-1 overflow-y-auto p-4"
};
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3"
};
const _hoisted_8 = {
  key: 1,
  class: "empty-state"
};
const _hoisted_9 = {
  class: "empty-state-icon"
};
const _hoisted_10 = {
  key: 2,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "aspect-[4/3] bg-gradient-to-br from-slate-100 to-slate-50 flex items-center justify-center relative overflow-hidden"
};
const _hoisted_13 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center text-slate-300"
};
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
  key: 1,
  class: "w-full h-full relative"
};
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = {
  class: "absolute inset-0 bg-black/20 flex items-center justify-center"
};
const _hoisted_18 = {
  class: "w-10 h-10 rounded-full bg-white/90 flex items-center justify-center shadow-lg"
};
const _hoisted_19 = {
  key: 2,
  class: "flex flex-col items-center text-slate-400"
};
const _hoisted_20 = {
  class: "w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center mb-1"
};
const _hoisted_21 = {
  class: "text-[10px] mt-1 text-slate-400 font-mono uppercase tracking-wider"
};
const _hoisted_22 = {
  key: 3,
  class: "flex flex-col items-center text-slate-400 px-4 py-2"
};
const _hoisted_23 = {
  class: "w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center mb-1"
};
const _hoisted_24 = {
  class: "text-[10px] text-slate-400 text-center line-clamp-2"
};
const _hoisted_25 = {
  class: "absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-200 flex items-center justify-center"
};
const _hoisted_26 = {
  class: "p-3"
};
const _hoisted_27 = {
  class: "flex items-center gap-1.5 mb-2"
};
const _hoisted_28 = {
  key: 0,
  class: "status-badge is-danger"
};
const _hoisted_29 = ["title"];
const _hoisted_30 = {
  class: "text-[11px] text-slate-400"
};
const _hoisted_31 = {
  key: 0,
  class: "grid-footer px-4 py-2.5 border-t border-slate-100/80 flex items-center justify-between shrink-0 bg-white"
};
import { FolderOpened, VideoPlay, Document, Tickets, ZoomIn, ArrowUp, ArrowDown, Picture } from '@element-plus/icons-vue';
export default {
  __name: 'AssetGrid',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 20
    },
    sortField: {
      type: String,
      default: 'createTime'
    },
    sortOrder: {
      type: String,
      default: 'DESC'
    }
  },
  emits: ['select', 'page-change', 'size-change', 'sort-change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const sortOptions = [{
      field: 'createTime',
      label: '时间'
    }, {
      field: 'name',
      label: '名称'
    }, {
      field: 'fileSize',
      label: '大小'
    }];
    function toggleSort(field) {
      const nextOrder = props.sortField === field && props.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      emit('sort-change', {
        field,
        order: nextOrder
      });
    }
    function typeLabel(type) {
      const map = {
        IMAGE: '图片',
        VIDEO: '视频',
        FILE: '文件',
        TEXT: '文本'
      };
      return map[type] || type;
    }
    function typeBadgeClass(type) {
      const map = {
        IMAGE: 'status-badge is-success',
        VIDEO: 'status-badge is-purple',
        FILE: 'status-badge is-cyan',
        TEXT: 'status-badge is-warning'
      };
      return map[type] || '';
    }
    function fileExtension(item) {
      // Try to extract from cover info or name
      if (item.name?.includes('.')) {
        const extension = item.name.split('.').pop();
        return extension ? extension.substring(0, 4) : 'FILE';
      }
      return 'FILE';
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.selectedId ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "text-sm text-primary-600 cursor-pointer hover:text-primary-700 transition-colors",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', null))
      }, " 清除选择 ")) : (_openBlock(), _createElementBlock("span", _hoisted_3)), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, s => {
        return _createElementVNode("button", {
          key: s.field,
          type: "button",
          class: _normalizeClass(["btn-text", {
            'is-active': __props.sortField === s.field
          }]),
          onClick: $event => toggleSort(s.field)
        }, [_createTextVNode(_toDisplayString(s.label) + " ", 1), __props.sortField === s.field ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "ml-0.5 transition-transform"
        }, {
          default: _withCtx(() => [__props.sortOrder === 'ASC' ? (_openBlock(), _createBlock(_unref(ArrowUp), {
            key: 0
          })) : (_openBlock(), _createBlock(_unref(ArrowDown), {
            key: 1
          }))]),
          _: 1
        })) : _createCommentVNode("", true)], 10, _hoisted_5);
      }), 64))])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [__props.loading && __props.list.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, i => {
        return _createElementVNode("div", {
          key: i,
          class: "bg-white rounded-xl border border-slate-200/60 p-3 animate-pulse"
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "aspect-[4/3] bg-gradient-to-br from-slate-100 to-slate-50 rounded-lg mb-3"
        }, null, -1), _createElementVNode("div", {
          class: "h-3 bg-slate-100 rounded w-3/4 mb-2"
        }, null, -1), _createElementVNode("div", {
          class: "h-2.5 bg-slate-100 rounded w-1/2"
        }, null, -1)]))]);
      }), 64))])) : !__props.loading && __props.list.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
        size: 36,
        class: "text-slate-300"
      }, {
        default: _withCtx(() => [_createVNode(_unref(FolderOpened))]),
        _: 1
      })]), _cache[4] || (_cache[4] = _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无素材", -1)), _cache[5] || (_cache[5] = _createElementVNode("p", {
        class: "empty-state-desc"
      }, "选择文件夹后上传或新建素材", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["asset-card bg-white rounded-xl border border-slate-200/80 cursor-pointer transition-all duration-200 overflow-hidden group hover:shadow-lg hover:shadow-slate-200/50 hover:border-slate-300/80 hover:-translate-y-0.5", __props.selectedId === item.id ? 'border-primary-400 ring-2 ring-primary-100 shadow-lg shadow-primary-100/50' : '']),
          onClick: $event => _ctx.$emit('select', item)
        }, [_createElementVNode("div", _hoisted_12, [item.type === 'IMAGE' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [item.coverUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.coverUrl,
          alt: item.name,
          class: "w-full h-full object-cover transition-transform duration-300 group-hover:scale-105",
          loading: "lazy"
        }, null, 8, _hoisted_14)) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          size: 36
        }, {
          default: _withCtx(() => [_createVNode(_unref(Picture))]),
          _: 1
        }))])) : item.type === 'VIDEO' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [item.coverUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.coverUrl,
          alt: item.name,
          class: "w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        }, null, 8, _hoisted_16)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_icon, {
          size: 20,
          class: _normalizeClass(item.coverUrl ? 'text-slate-700' : 'text-slate-400')
        }, {
          default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
          _: 1
        }, 8, ["class"])])])])) : item.type === 'FILE' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_icon, {
          size: 32
        }, {
          default: _withCtx(() => [_createVNode(_unref(Document))]),
          _: 1
        })]), _createElementVNode("span", _hoisted_21, _toDisplayString(fileExtension(item)), 1)])) : item.type === 'TEXT' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_icon, {
          size: 24
        }, {
          default: _withCtx(() => [_createVNode(_unref(Tickets))]),
          _: 1
        })]), _createElementVNode("span", _hoisted_24, _toDisplayString(item.description || '文本素材'), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [item.type === 'IMAGE' ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 24,
          class: "text-white opacity-0 group-hover:opacity-100 transition-all duration-200 transform scale-75 group-hover:scale-100 drop-shadow-lg"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ZoomIn))]),
          _: 1
        })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("span", {
          class: _normalizeClass(["text-[10px] font-medium px-1.5 py-0.5 rounded-md", typeBadgeClass(item.type)])
        }, _toDisplayString(typeLabel(item.type)), 3), item.status === 'DISABLED' ? (_openBlock(), _createElementBlock("span", _hoisted_28, "已禁用")) : _createCommentVNode("", true)]), _createElementVNode("p", {
          class: "text-sm font-semibold text-slate-800 truncate mb-0.5",
          title: item.name
        }, _toDisplayString(item.name), 9, _hoisted_29), _createElementVNode("p", _hoisted_30, _toDisplayString(item.createBy), 1)])], 10, _hoisted_11);
      }), 128))]))])), [[_directive_loading, __props.loading]]), __props.total > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_pagination, {
        "current-page": __props.current,
        "page-size": __props.size,
        total: __props.total,
        "page-sizes": [20, 40, 60, 100],
        layout: "total, sizes, prev, pager, next",
        small: "",
        background: "",
        class: "!text-xs",
        onCurrentChange: _cache[1] || (_cache[1] = $event => _ctx.$emit('page-change', $event)),
        onSizeChange: _cache[2] || (_cache[2] = $event => _ctx.$emit('size-change', $event))
      }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)]);
    };
  }
};